import UserForm from "./components/UserForm";

const UserCreate = () => {
  return <UserForm mode="create" />;
};

export default UserCreate;
